import { JobsStatus } from "../../Models/ProjectJobsStatus";

export interface IProjectJobsStatusModalState {
    projectId: number | undefined;
    projectTimezoneOffset: number;
    data?: JobsStatus | null;
    loaded: boolean;
    shouldRefresh: boolean;
    errorCode?: string | null;
}

export const initialProjectJobsStatusModalState: IProjectJobsStatusModalState = {
    projectId: 0,
    projectTimezoneOffset: 0,
    data: null,
    loaded: false,
    shouldRefresh: false,
    errorCode: null,
};
